import { render, staticRenderFns } from "./OrdersAvailability.vue?vue&type=template&id=4b6589d4"
import script from "./OrdersAvailability.vue?vue&type=script&lang=js"
export * from "./OrdersAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports